export default (function (condition, message) {
    if (condition && process.env.NODE_ENV !== 'production') {
        console.warn(message); // eslint-disable-line
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ra-core/esm/util/warning.js
// module id = 228
// module chunks = 0